/**
 * Description: Filter Audit Batch Component on review page
 */
import React from 'react';
import {
  FormSection
} from 'AWS-UI-Components-React';
import { FilterCommon } from '../filterSection.jsx'

export class FilterBatchOutfits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_options: {
        outfit_source: "",
        after_date: "",
        before_date: "",
        marketplace: "0",
        seed_category: ""
      },
      errorMessage: ""
    };
    this.filterCallback = this.filterCallback.bind(this);
  }

  filterCallback(filter_options) {
    if (filter_options.marketplace == "0") {
      alert("Please select a marketplace");
      return null;
    }
    
    this.state.filter_options.outfit_source = filter_options.outfit_source;
    this.state.filter_options.after_date = filter_options.after_date;
    this.state.filter_options.before_date = filter_options.before_date;
    this.state.filter_options.marketplace = filter_options.marketplace;
    this.state.filter_options.seed_category = filter_options.seed_category;

    return this.props.getAuditBatchCallBack(this.state.filter_options);
  }

  render() {
    const filter_labels = {
      after_date: "Created After (inclusive):",
      before_date: "Created Before (inclusive):",
      button_text: "Load New Batch"
    }              

    return (
      <div className="awsui">
        <FormSection header="Filter Outfits" expandable={true} expanded={true}>
          <div data-awsui-column-layout-root="true" className="filter-options">
            <div>
              <FilterCommon filter_labels={filter_labels} filterCallback={this.filterCallback} />
            </div>   
          </div>
        </FormSection>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/reviewPage/filterBatchOutfitsSection.jsx